import { useEffect, useState } from "react";
import { signUpInitiativeMetaData } from "../auth/login.service";

export const useSignupMetaData = (countryId) => {

  const [userTypes, setUserTypes] = useState([]);
  const [initiativeEcosystem, setInitiativeEcosystem] = useState([]);
  const [ecosystemIntegrator, setEcosystemIntegrator] = useState([]);
  const [countryList, setcountryList] = useState([]);

  useEffect(() => {
    const fetchMetaData = async () => {
      try {
       if (countryId) {
          const res = await signUpInitiativeMetaData(countryId);
          if (res.statusCode === 200) {
            setUserTypes(res.data.userTypes || []);
            setcountryList(res.data.countryData || []);
            setInitiativeEcosystem(res.data.initiativeEcosystem || []);
            setEcosystemIntegrator(res.data.ecosystemIntegrator || []);
          } else {
            setUserTypes([]);
            setInitiativeEcosystem([]);
            setEcosystemIntegrator([]);
          }
        } else {
          console.log("Country id not provided")
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchMetaData();
  }, [countryId]);

  return { userTypes, initiativeEcosystem, ecosystemIntegrator,countryList};
};
